<template>
  <div id="verify-tree-grid" class="grid-view">
    <div class="main-content">
      <div slot="operations">
        <div>
          <el-form
            label-width="100px"
            label-position="left"
            style="margin-right:10px;padding-top: 10px"
          >
            <el-row>
              <el-col :span="6">
                <el-form-item
                  class="query-input-spacing"
                  :label="$t('SeaExport.BusinessNo')"
                  prop="jobNo"
                >
                  <el-input v-model="query.jobNo" no="1" />
                </el-form-item>
                <el-form-item
                  class="query-input-spacing"
                  :label="$t('CargoMsg.Cargo_CarrierShip')"
                  prop="carrierId"
                >
                  <cargo-company-select
                    no="2"
                    :method-params="{companyLob:'seaExport',seaCmp:true,active:true}"
                    :default-value="query.carrierId||''"
                    :placeholder="' '"
                    @change="p=>{query.carrierId=p.value}"
                  />
                </el-form-item>
                <el-form-item
                  class="query-input-spacing"
                  :label="$t('CargoMsg.Cargo_BusinessDate')"
                  prop="businessData"
                >
                  <div style="padding-bottom: 5px;display: flex">
                    <el-date-picker
                      v-model="query.businessDateStart"
                      no="3"
                      style="width: 100%"
                      type="date"
                      value-format="yyyy-MM-dd"
                    />
                    <span>{{ $t('CargoMsg.Cargo_To') }}</span>
                    <el-date-picker
                      v-model="query.businessDateEnd"
                      no="4"
                      style="width: 100%"
                      type="date"
                      value-format="yyyy-MM-dd"
                    />
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  class="query-input-spacing"
                  :label="$t('SeaExport.Mbl2')"
                  prop="mblNo"
                >
                  <el-input v-model="query.mblNo" no="5" />
                </el-form-item>
                <el-form-item
                  class="query-input-spacing"
                  :label="$t('SeaExport.Hbl2')"
                  prop="hblNo"
                >
                  <el-input v-model="query.hblNo" no="6" />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  class="query-input-spacing"
                  :label="$t('SeaExport.Customer')"
                  prop="customerId"
                >
                  <cargo-company-select
                    no="7"
                    class="shipper-selector"
                    popper-class="shipper-selector-popper"
                    :method-params="{customer:true}"
                    :default-value="query.customerId||''"
                    style="flex: 1;"
                    :placeholder="' '"
                    @change="p=>{query.customerId=p.value}"
                  />
                </el-form-item>
                <el-form-item
                  class="query-input-spacing"
                  :label="$t('SeaExport.SoNo')"
                  prop="soNo"
                >
                  <el-input v-model="query.soNo" no="8" />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div>
          <el-button no="9" type="primary" @click="queryHandler">{{ $t('CargoMsg.Cargo_Search') }}</el-button>
          <el-button no="10" type="primary" @click="clearPage">{{ $t('CargoMsg.Cargo_ResetFilter') }}</el-button>
          <!--新增-->
          <el-button no="11" :disabled="!btn.btNew" type="primary" @click="addHandler">{{ $t('common.btn.new') }}</el-button>
          <!--编辑-->
          <el-button no="12" :disabled="!btn.btEdit" type="primary" @click="editHandler">{{ $t('SeaExport.Edit') }}</el-button>
          <!--删除-->
          <el-button no="13" :disabled="!btn.btRemove" type="primary" @click="deleteHandler">{{ $t('SeaExport.Delete') }}</el-button>
          <!--复制-->
          <el-button no="14" :disabled="!btn.btnClone" type="primary" @click="cloneHandler">{{ $t('SeaExport.Clone') }}</el-button>
          <!--送出-->
          <el-button no="15" :disabled="!btn.btnSend" type="primary" @click="onSendHandler">{{ $t('SeaExport.Send2') }}</el-button>
        </div>
      </div>
      <div style="display:flex;height:100%">
        <div style="display: flex;flex-direction: column;width: 50%;" class="section">
          <cargo-ag-grid
            config-module="9500001"
            :locale-text-func="_i18nGridLocalText"
            :grid-options="businessList.gridOptions"
            :column-defs="businessList.columnDefs"
            :row-data="businessList.rowData"
            :grid-params.sync="businessList.gridParams"
            class="ag-theme-balham"
            style="width: 100%;"
            @gridReady="onGridReadyByBL"
          />
          <cargo-pagination
            config-module="9500003"
            :total="businessList.total"
            :page.sync="businessList.filter.pageNum"
            :limit.sync="businessList.filter.pageSize"
            @pagination="toQueryByPage"
          />
        </div>
        <div style="display: flex;flex-direction: column;width: 50%;height: 100%">
          <cargo-ag-grid
            config-module="9500002"
            :locale-text-func="_i18nGridLocalText"
            :grid-options="fileList.gridOptions"
            :column-defs="fileList.columnDefs"
            :row-data="fileList.rowData"
            :grid-params.sync="fileList.gridParams"
            class="ag-theme-balham"
            style="width: 100%;"
            @gridReady="onGridReadyByFL"
          />
          <div class="section">
            <div>
              <el-form :inline="true" label-width="60px" label-position="left" style="padding-top:5px">
                <el-form-item :label="$t('SeaExport.FileType')" class="custom">
                  <cargo-advance-select
                    no="16"
                    filterable
                    :select-type="selectTypeNames.basic_data_TransmitFileType"
                    :default-value="fileList.selectedFile.fileType"
                    style="width:160px;"
                    :disabled="true"
                  />
                </el-form-item>
                <el-form-item :label="$t('SeaExport.FileNo')" class="custom">
                  <el-input v-model="fileList.selectedFile.fileNo" no="17" :readonly="true" style="width:250px" :disabled="true" />
                </el-form-item>
                <el-form-item v-if="fileView.txtCheckStatusOfCustomsDeclaration" class="label-none custom">
                  <el-button no="18" style="text-decoration: underline;border: 0;" @click="stateQueryClickHandler">{{ this.$t('SeaExport.CheckStatusOfCustomsDeclaration') }}</el-button>
                </el-form-item>
                <el-form-item v-if="fileView.checkPreRecordedCustomsDeclaration" class="label-none custom">
                  <el-dropdown
                    no="19"
                    split-button
                    type="primary"
                    trigger="click"
                    @command="onLogPopUpMenu"
                  >
                    {{ fileView.command }}
                    <el-dropdown-menu v-for="item in fileView.buttonArry" :key="item.id" slot="dropdown">
                      <el-dropdown-item :command="item.value">{{ item.value }}</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </el-form-item>
              </el-form>
              <el-form :inline="true" label-width="60px" label-position="left">
                <el-form-item :label="$t('SeaExport.TenBitCode')" class="custom">
                  <el-input v-model="fileList.selectedFile.tenDigitCode" no="20" :readonly="true" style="width:160px" maxlength="10" :disabled="true" />
                </el-form-item>
                <el-form-item :label="$t('SeaExport.OperatingCompany')" class="custom">
                  <el-input v-model="fileList.selectedFile.companyCname" no="21" :readonly="true" style="width:250px" :disabled="true" />
                </el-form-item>
              </el-form>
              <el-form :inline="true" label-width="60px" label-position="left">
                <el-form-item :label="$t('SeaExport.ReceiverCompanyName')" class="custom">
                  <el-input v-model="fileList.selectedFile.receiveCompany" no="22" :readonly="true" style="width:160px" :disabled="true" />
                </el-form-item>
                <el-form-item :label="$t('SeaExport.Receiver2')" class="custom">
                  <el-input v-model="fileList.selectedFile.receivePerson" no="23" :readonly="true" style="width:100px" :disabled="true" />
                </el-form-item>
                <el-form-item :label="$t('SeaExport.Tel')" class="custom">
                  <el-input v-model="fileList.selectedFile.receiveTel" no="24" :readonly="true" style="width:120px" :disabled="true" />
                </el-form-item>
              </el-form>
              <el-form :inline="true" label-width="60px" label-position="left">
                <el-form-item :label="$t('SeaExport.CustomsDeclarationPages')" class="custom">
                  <el-input v-model="fileList.selectedFile.customsPageNumber" no="25" :readonly="true" style="width:160px" :disabled="true" />
                  <el-checkbox v-model="fileList.selectedFile.customsTransfer" :disabled="true" style="padding-left:10px">{{ $t('SeaExport.CustomsTransitOrNot') }}</el-checkbox>
                </el-form-item>
                <el-form-item :label="$t('SeaExport.TradeMethod')" class="custom">
                  <el-input v-model="fileList.selectedFile.tradeModeName" no="26" :readonly="true" style="width:140px" :disabled="true" />
                </el-form-item>
              </el-form>
              <el-form :inline="true" label-width="60px" label-position="left">
                <el-form-item :label="$t('SeaExport.CustomsBroker')">
                  <cargo-company-select
                    no="27"
                    :disabled="true"
                    :method-params="{customsBroker:true,seaExport:true,active:true}"
                    :default-value="fileList.selectedFile.customsBroker||''"
                    :custom-style="'width:160px;'"
                    @change="p=>{fileList.selectedFile.customsBroker=p.value}"
                  />
                </el-form-item>
                <el-checkbox v-model="fileList.selectedFile.tax" no="28" :disabled="true" style="padding-top:5px;margin-right: 15px;">{{ $t('SeaExport.TakeByCustomsBroker') }}</el-checkbox>
                <el-form-item v-show="fileList.selectedFile.fileType==='3'" :label="$t('SeaExport.DateOfDeclaration')">
                  <el-date-picker
                    v-model="fileList.selectedFile.declareDate"
                    no="29"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :disabled="true"
                    style="width:150px;"
                  />
                </el-form-item>
              </el-form>
              <el-form :inline="true" label-width="60px" label-position="left">
                <el-form-item :label="$t('SeaExport.ExpressAddress')" class="custom">
                  <el-input
                    v-model="fileList.selectedFile.expressAddress"
                    no="30"
                    type="textarea"
                    :rows="3"
                    :readonly="true"
                    style="width:250px"
                    :disabled="true"
                    @dblclick.native="showAdvanceTextDialog($t('SeaExport.ExpressAddress'),fileList.selectedFile.expressAddress,val=>{fileList.selectedFile.expressAddress=val})"
                  />
                </el-form-item>
                <el-form-item :label="$t('SeaExport.Remarks')" class="custom">
                  <el-input
                    v-model="fileList.selectedFile.remark"
                    no="31"
                    type="textarea"
                    :rows="3"
                    :readonly="true"
                    style="width:250px"
                    :disabled="true"
                    @dblclick.native="showAdvanceTextDialog($t('SeaExport.Remarks'),fileList.selectedFile.remark,val=>{fileList.selectedFile.remark=val})"
                  />
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-input v-model="advanceTextDialog.value" no="32" type="textarea" rows="10" />
      <span slot="footer">
        <el-button no="33" type="primary" @click="finishAdvanceText">{{ $t('common.btn.confirm') }}</el-button>
        <el-button
          no="34"
          @click="advanceTextDialog.visible=false"
        >{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>

    <customs-info-file-dialog ref="customsInfoFile" :visible.sync="customsInfoFiledialog.visible" :model="customsInfoFiledialog.model" :category="customsInfoFiledialog.category" />

    <!-- 文件编辑弹框 -->
    <file-dialog ref="fileDialog" :visible.sync="editDialog.visible" :backable="editDialog.backable" :selected-file="fileList.selectedFile" :job="job" @successHandler="successHandler" />

    <dc-send-out-window
      ref="dcSendOut"
      :send-out-dialog="sendOutDialog"
      :visible="sendOutDialog.visible"
      :job="job"
      :selected-files="fileList.selectedFiles"
      @dcSendOutVisible="sendOutDialog.visible=false"
      @successHandler="successHandler"
    />
  </div>
</template>

<script>
import CargoGridShowBigContent from '@/components/Cargo/grid/cargoGridShowBigContent'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { cacheName, cache } from '@/utils/cacheManager'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { getLoading } from '@/utils/utilBaseElement'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import CargoDateTimePicker from '@/components/Cargo/Common/CargoDateTimePicker'
import {
  delFile,
  fileList,
  findKeyForCustoms,
  getCustomsStatusURL,
  getGetCustomsStatusResult
} from '@/api/seaExport/file'
import { stateQueryClickHandler } from '@/class/cargo/model/utils/file'
import { sortByMultiField } from '@/utils'
import ColumnUtils from '@/utils/ColumnUtils'
import * as TransmitFileType from '@/class/cargo/model/parameters/TransmitFileTypeConstants'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import { queryJobByFilePageableFunc } from '@/api/booking/job'
import { PriceUtils } from '@/class/cargo/model/utils/PriceUtils'
import CustomsInfoFileDialog from '@/components/Cargo/Job/customsInfoFileDialog'
import { DocumentManage } from '@/utils/commonUtil'
import fileDialog from '@/components/Cargo/Job/fileDialog'
import DateUtils from '@/utils/dateUtils'
import dcSendOutWindow from '@/views/cargo/v0/Clearing/components/DocumentCirculation/dcSendOutWindow'
import { getObjectByCache } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { Company } from '@/class/model/mdm/Company'

export default {
  name: 'SeDocInputDetail',
  components: {
    CargoAdvanceSelect,
    cargoUserSelect,
    fileDialog,
    CargoDateTimePicker,
    stateQueryClickHandler,
    dcSendOutWindow,
    cargoCompanySelect,
    CustomsInfoFileDialog,
    CargoGridShowBigContent
  },
  props: {
  },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      documentManage: new DocumentManage(),
      btn: {
        btNew: false,
        btnClone: false,
        btEdit: false,
        btRemove: false,
        btnSend: false
      },
      query: {
        jobNo: '',
        mblNo: '',
        customerId: 0,
        carrierId: 0,
        hblNo: '',
        soNo: '',
        businessDateStart: null,
        businessDateEnd: null
      },
      businessList: {
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
          suppressRowClickSelection: true, // 如果为true， 则单击行时不会发生行选择。当您想要专门选择复选框时使用。
          onRowClicked: event => {
            this.onRowClickedByBL(event.data)
          },
          defaultColDef: {
            resizable: true
          },
          context: {
            componentParent: this
          }
        },
        columnDefs: [
          {
            headerName: this.$t('SeaExport.BusinessType'), field: 'lob', width: 100, colId: 'lob',
            cellRenderer: (params) => {
              return ColumnUtils.jobBussStateLabelFunc(params.value)
            }
          },
          { headerName: this.$t('SeaExport.BusinessNo'), field: 'jobNo', width: 100, colId: 'jobNo' },
          { headerName: this.$t('SeaExport.CustomerName'), field: 'customerId', width: 100, colId: 'customerId',
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
            }
          },
          { headerName: this.$t('SeaExport.Mbl2'), field: 'mblNo', width: 100, colId: 'mblNo' },
          { headerName: this.$t('CargoMsg.Cargo_SailingDay'), field: 'eTD', width: 100, colId: 'eTD',
            cellRenderer: (params) => {
              return DateUtils.formatStandardDate(params.value)
            }
          },
          { headerName: this.$t('SeaExport.Operation'), field: 'op', width: 100, colId: 'op',
            cellRenderer: params => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
            }
          },
          { headerName: this.$t('SeaExport.Sales'), field: 'sales', width: 100, colId: 'sales',
            cellRenderer: params => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
            }
          }
        ],
        rowData: [],
        gridParams: {},
        total: 0,
        filter: {
          pageNum: 1,
          pageSize: 10,
          branchId: 0 // 分公司ID
        },
        gridApi: null,
        selectedData: null
      },
      fileList: {
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
          suppressRowClickSelection: true, // 如果为true， 则单击行时不会发生行选择。当您想要专门选择复选框时使用。
          // 行点击事件
          onRowClicked: this.onRowClickedByFL,
          // 行勾选事件
          onRowSelected: this.onRowSelected,
          // 选中 勾选框或者其他列 都会触发
          onCellFocused: (event) => {
            this.onCellFocusedByFL(event)
          },
          defaultColDef: {
            resizable: true
          },
          context: {
            componentParent: this
          }
        },
        columnDefs: [
          {
            headerName: '', width: 30, checkboxSelection: true,
            suppressSorting: true, suppressMenu: true, suppressSizeToFit: true, suppressResize: true,
            headerCheckboxSelection: true
          },
          {
            headerName: this.$t('SeaExport.FileType'),
            field: 'uuid',
            width: 120,
            cellRenderer: (params) => {
              return this.convertFileTypeNameByCodeLob(params.value)
            }
          },
          { headerName: this.$t('SeaExport.FileNo'), field: 'fileNo', width: 120, colId: 'fileNo' },
          { headerName: this.$t('SeaExport.CustomsNo'), field: 'customsNo', width: 180, colId: 'customsNo' },
          {
            headerName: this.$t('SeaExport.FileStatus'),
            field: 'state',
            width: 120,
            cellRenderer: (params) => {
              return ColumnUtils.fileStateLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('SeaExport.SendingDate'),
            field: 'sendDate',
            width: 120,
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('SeaExport.DateOfDeclaration'),
            field: 'declareDate',
            width: 120,
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('SeaExport.ViewFile'),
            field: 'originFileId',
            width: 120,
            noExport: true,
            cellRenderer: params => {
              const methodPath = this.documentManage.getPath('showFileDetailHandler')
              if (params.value) {
                return `<a onclick="${methodPath}('${params.value}')" style="text-decoration: underline;">${this.$t('SeaExport.ChargebackFile')}</a>`
              }
            }
          }
        ],
        rowData: [],
        gridParams: {},
        gridApi: null,
        selectedFile: {},
        selectedFiles: []
      },
      fileView: {
        isCustomsStatusTitle: false,
        txtCheckStatusOfCustomsDeclaration: false,
        checkPreRecordedCustomsDeclaration: false,
        command: '',
        customsDeclarationUrl: '',
        releaseNoticeUrl: '',
        buttonArry: []
      },
      advanceTextDialog: {
        visible: false,
        title: '',
        value: '',
        successCallback: null
      },
      job: {
        lob: '',
        soNo: '',
        uuid: '',
        containerLoadType: '',
        bookingAgent: 0,
        customerId: 0,
        customerContact: '',
        opOffice: 0,
        mbl: '',
        customsBroker: ''
      },
      customsInfoFiledialog: {
        visible: false,
        model: null
      },
      editDialog: {
        visible: false,
        backable: false
      },
      sendOutDialog: {
        visible: false,
        sendType: 1,
        customerType: 1,
        printFlag: false,
        formData: {
          receiveCompany: '',
          receivePerson: '',
          receiveAddress: '',
          receiveTel: '',
          expressNo: ''
        }
      },
      cbAutoRefresh: true
    }
  },
  computed: {

  },
  async created() {
    await this.preloadBasicData()
    await cache.load(cacheName.OFFICE, cacheName.CONFIG)
    this.office = cache.office
  },
  beforeMount() {
    const context = this
    this.documentManage.set('showFileDetailHandler', function(value) {
      context.showFileDetailHandler(value)
    })
  },
  beforeDestroy() {

  },
  methods: {
    onGridReadyByBL(p) {
      this.businessList.gridApi = p.api
    },
    onGridReadyByFL(p) {
      this.fileList.gridApi = p.api
    },
    // 行点击触发事件
    onRowClickedByBL(event) {
      if (!event) return
      this.businessList.selectedData = null
      const node = event
      if (node.uuid) {
        this.businessList.selectedData = node
        this.fileList.selectedFiles = []
        this.btn.btnSend = false
        Object.keys(this.job).forEach((key) => {
          this.job[key] = node[key]
        })
        // 根据业务查询对应单证数据
        this.queryFileListHandler()
      }
    },
    // 行点击触发事件
    onRowClickedByFL(event) {
      if (!event) return
      this.fileList.selectedFile = {}
      if (event.data) {
        this.fileList.selectedFile = event.data
        this.checkButtonsState()
      }
    },
    onRowSelected(event) {
      if (!event || !event.data) return
      this.onRowClickedByFL(event)
      if (event.node.isSelected()) {
        this.fileList.selectedFiles.push(event.data)
      } else {
        this.fileList.selectedFiles = this.fileList.gridApi.getSelectedRows()
      }
      this.checkButtonsState()
    },
    async showFileDetailHandler() {
      let customsInfo = null
      await findKeyForCustoms(this.job.uuid).then(res => {
        customsInfo = res.data
      })
      if (customsInfo) {
        const list = []
        if (customsInfo.businessDocuments) {
          customsInfo.businessDocuments.find(x => {
            if (x.documentCategory === 1001) {
              list.push(x)
            }
          })
          customsInfo.businessDocuments = list
        }
        this.customsInfoFiledialog.model = customsInfo
        this.customsInfoFiledialog.visible = true
      }
    },
    // 初始化配置参数
    async preloadBasicData() {
      await cache.load(cacheName.CONFIG)
    },
    clearPage() {
      this.query = PriceUtils.resetFilter(this.query)
    },
    queryHandler() {
      this.businessList.filter.pageNum = 1
      this.toQueryByPage()
    },
    // 查询
    toQueryByPage() {
      Object.keys(this.query).forEach((key) => {
        this.businessList.filter[key] = this.query[key]
      })
      this.businessList.filter.pageNum = this.businessList.filter.pageNum
      this.businessList.filter.pageSize = this.businessList.filter.pageSize
      this.businessList.filter.branchId = this.$store.getters.currentOfficeId
      this.loading = getLoading()
      queryJobByFilePageableFunc(this.businessList.filter).then(res => this.handleQueryData(res)).catch((err) => {
        this.$message.error(err)
        this.loading.close()
      })
    },
    // 查询返回结果[公用]
    handleQueryData(res) {
      this.businessList.rowData = res.data.list
      this.businessList.filter.pageNum = res.data.pageNum
      this.businessList.filter.pageSize = res.data.pageSize
      this.businessList.total = Number(res.data.total)
      // 初始化选中业务
      this.businessList.selectedData = null
      // 初始化文件列表
      this.fileList.rowData = []
      this.fileList.selectedFile = {}
      this.fileList.selectedFiles = []
      this.businessList.gridApi.clearFocusedCell()
      this.fileList.gridApi.clearFocusedCell()
      this.loading.close()
    },
    // 选中业务查询文件列表
    queryFileListHandler() {
      this.fileList.selectedFile = {}
      this.fileList.gridApi.clearFocusedCell()
      fileList(this.job.uuid).then(res => {
        this.fileList.rowData = res.data
        if (res.data && res.data.length > 0) {
          this.fileList.selectedFile = res.data[0]
          this.fileList.gridApi.setFocusedCell(0, 'uuid')
        }
        this.checkButtonsState()
      })
    },
    convertFileTypeNameByCodeLob(uuid) {
      const currentRow = this.fileList.rowData.find(x => x.uuid === uuid)
      if (currentRow) {
        return ColumnUtils.getFileTypeNameByCodeLob(this.job.lob, currentRow.fileType)
      }
      return ''
    },
    showAdvanceTextDialog(title, value, successCallback) {
      this.advanceTextDialog.title = title
      this.advanceTextDialog.value = value
      this.advanceTextDialog.successCallback = successCallback
      this.advanceTextDialog.visible = true
    },
    finishAdvanceText() {
      const successCallback = this.advanceTextDialog.successCallback
      if (successCallback && typeof successCallback === 'function') {
        successCallback(this.advanceTextDialog.value)
      }
      this.advanceTextDialog.visible = false
    },
    onCellFocusedByFL(event) {
      if (this.fileList.gridApi && event) {
        this.fileList.gridApi.forEachNode(node => {
          if (node.rowIndex === event.rowIndex) {
            this.fileList.selectedFile = node.data
          }
        })
      }
      this.checkButtonsState()
    },
    checkSelectedData() {
      if (this.fileList.selectedFile && this.fileList.selectedFile.uuid) {
        return true
      }
      return false
    },
    checkButtonsState() {
      this.btn.btNew = this.businessList.selectedData
      this.btn.btnClone = this.checkSelectedData()
      const selectedFile = this.fileList.selectedFile
      if (this.checkSelectedData()) {
        this.btn.btEdit = selectedFile.state <= 1 || this.$checkPermission(['button_ACFile_CRFileEdit'])
        this.btn.btSend = true
        this.btn.btRemove = selectedFile.state < 2 || this.$checkPermission(['button_ACFile_CRFileEdit'])
      } else {
        this.btn.btEdit = false
        this.btn.btSend = false
        this.btn.btRemove = false
      }
      this.btn.btnSend = false
      if (this.fileList.selectedFiles.length > 0) {
        let ok = true
        for (const f of this.fileList.selectedFiles) {
          if (f.state > 1 || !f.uuid) {
            ok = false
            break
          }
        }
        this.btn.btnSend = ok
      }
      this.loadUrl()
      this.showTradeMode()
    },
    async loadUrl() {
      let soNo = ''
      // url置空，防止因为缓存显示不正常
      this.fileView.checkPreRecordedCustomsDeclaration = false
      this.fileView.releaseNoticeUrl = ''
      this.fileView.customsDeclarationUrl = ''
      if (this.fileList.selectedFile != null && this.fileList.selectedFile.fileType === '3') {
        if (this.job.lob === 'SE') {
          soNo = this.job.soNo
        } else if (this.job.lob === 'AE' || this.job.lob === 'SI' || this.job.lob === 'AI') {
          soNo = this.fileList.selectedFile.fileNo
        }
        if (soNo) {
          await this.getYLDUrlResult()
        }
      }
    },
    showTradeMode() {
      this.fileView.txtCheckStatusOfCustomsDeclaration = false
      if (this.fileList.selectedFile) {
        if (this.fileList.selectedFile.tradeMode === 1) {
          this.fileList.selectedFile.tradeModeName = this.$t('Message.GeneralTrade')
        } else if (this.fileList.selectedFile.tradeMode === 2) {
          this.fileList.selectedFile.tradeModeName = this.$t('Message.ProcessingWithSuppliedMaterial')
        } else if (this.fileList.selectedFile.tradeMode === 3) {
          this.fileList.selectedFile.tradeModeName = this.$t('Message.ProcessingTrade')
        } else if (this.fileList.selectedFile.tradeMode === 4) {
          this.fileList.selectedFile.tradeModeName = this.$t('Message.SamplesOfAdvertisingProductsA')
        } else if (this.fileList.selectedFile.tradeMode === 5) {
          this.fileList.selectedFile.tradeModeName = this.$t('SeaExport.OtherImportsFree')
        }
        const interchangeCode = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_TransmitFileType, 'code', this.fileList.selectedFile.fileType, 'interchangeCode')
        this.fileView.txtCheckStatusOfCustomsDeclaration = (interchangeCode === TransmitFileType.BGD_TYPE)
      }
    },
    getYLDUrlResult() {
      getCustomsStatusURL(this.fileList.selectedFile).then(res => this.getURLResultHandler(res.data))
    },
    getURLResultHandler(value) {
      if (!value) return
      const url1 = value['releaseNotice']
      const url2 = value['customsDeclaration']

      if (!(!url1 && !url2)) {
        this.fileView.checkPreRecordedCustomsDeclaration = true
        // 动态设置下拉框
        if (url2) {
          this.fileView.customsDeclarationUrl = url2
          this.fileView.buttonArry.push({ id: 1,
            value: this.$t('SeaExport.CheckPreRecordedCustomsDeclaration') })
        }
        if (url1) {
          this.fileView.releaseNoticeUrl = url1
          this.fileView.buttonArry.push({ id: 2,
            value: this.$t('SeaExport.CheckRecordedCustomsDeclaration') })
        }
        this.fileView.command = this.fileView.buttonArry[0].value
      }
    },
    onLogPopUpMenu(val) {
      if (parseInt(cache.config.get('CustomerStatusQueryModel')) === 0) {
        this.findCustomerServiceByName(0)
      } else {
        switch (val) {
          case this.$t('SeaExport.CheckPreRecordedCustomsDeclaration'):
            if (this.fileView.customsDeclarationUrl.indexOf('http://') < 0) {
              this.$message.warning(this.fileView.customsDeclarationUrl)
              return
            }
            window.open(this.fileView.customsDeclarationUrl)
            break
          case this.$t('SeaExport.CheckRecordedCustomsDeclaration'):
            if (this.fileView.releaseNoticeUrl.indexOf('http://') < 0) {
              this.$message.warning(this.fileView.releaseNoticeUrl)
              return
            }
            window.open(this.fileView.releaseNoticeUrl)
            break
        }
      }
    },
    // 报关状态查询
    async stateQueryClickHandler() {
      const queryModel = parseInt(cache.config.get('CustomerStatusQueryModel'))
      const bExcute = await stateQueryClickHandler(queryModel, this.fileList.selectedFile, this.job)
      if (!bExcute) return
      await getGetCustomsStatusResult(this.fileList.selectedFile).then(res => {
        this.getGetCustomsStatusResultHander(res.data)
      })
    },
    getGetCustomsStatusResultHander(data) {
      this.fileView.isCustomsStatusTitle = true
      this.rowDataCustomsStatus = sortByMultiField(data, ['RECEIPT_DATE'], true)
    },
    addHandler() {
      if (!this.job || !this.job.uuid) {
        this.$message.warning(this.$t('Message.TheBookingDoesNotExistAndCannotBeAdded'))
      } else {
        this.$nextTick(() => {
          this.editDialog.visible = true
          this.editDialog.backable = true
          this.$refs.fileDialog.onShow('add')
        })
      }
    },
    editHandler() {
      if (!this.fileList.selectedFile) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      this.editDialog.visible = true
      this.editDialog.backable = false
      this.$refs.fileDialog.onShow('edit')
    },
    cloneHandler() {
      if (!this.fileList.selectedFile) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      this.editDialog.visible = true
      this.editDialog.backable = true
      this.$refs.fileDialog.onShow('clone')
    },
    deleteHandler() {
      const rows = this.fileList.gridApi.getSelectedRows()
      if (!rows || rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      this.$confirm(this.$t('SeaExport.DeleteNumRecord').replace('{0}', rows.length), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.yes'),
        cancelButtonText: this.$t('common.btn.no'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(async() => {
        try {
          this.loading = getLoading()
          for (const item of rows) {
            await delFile(item.uuid)
          }
        } finally {
          this.loading.close()
          await this.successHandler()
          this.$message.success(this.$t('common.tips.deleteSuccess'))
        }
      }).catch(() => {
      })
    },
    async successHandler() {
      this.btn.btnSend = false
      this.fileList.selectedFiles = []
      await this.queryFileListHandler()
      this.$nextTick(() => {
        this.onCellFocusedByFL(null)
      })
    },
    // =============================送出 ==================================
    onSendHandler() {
      this.sendOutDialog.visible = true
      this.sendOutDialog.sendType = 0
      this.sendOutDialog.customerType = this.sendOutDialog.sendType
      this.clearForm()
      this.setByCompanyId(this.job.bookingAgent)
      this.sendOutDialog.formData.expressNo = this.fileList.selectedFile.sendExpressNo
    },
    clearForm() {
      this.sendOutDialog.formData.receiveCompany = ''
      this.sendOutDialog.formData.receiveAddress = ''
      this.sendOutDialog.formData.receivePerson = ''
      this.sendOutDialog.formData.receiveTel = ''
      this.sendOutDialog.formData.expressNo = ''
    },
    async setByCompanyId(cmpIdx) {
      const companyCache = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', cmpIdx)
      if (!companyCache) {
        return
      }
      this.sendOutDialog.formData.receiveCompany = companyCache.chineseName
      this.sendOutDialog.formData.receiveAddress = companyCache.address
      let company = { cmpIdx: cmpIdx }
      company = new Company(company)
      let contact = null
      if (company != null) {
        const contacts = await company.getContactsBycmpIdx()
        if (contacts) {
          for (const item of contacts) {
            if (item.defaultContact) {
              contact = item
              break
            }
          }
          if (contact) {
            this.sendOutDialog.formData.receivePerson = contact.contactPerson
            this.sendOutDialog.formData.receiveTel = contact.telephone
          }
        }
      }
    }
    // =============================送出 end==================================
  }
}
</script>

<style lang="scss">
  #app #verify-tree-grid {
    .main-inner-row {
      display: flex;
      padding-top: 10px;
      padding-bottom: 10px;
    }
    .query-input-spacing {
      padding-right: 10px;
    }
  }
</style>
